/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import styles from './FormControls.module.scss';

const AddOrRemoveButtonControl: React.StatelessFunctionalComponent<Props> = ({
  form,
  field,
  controls = null,
  t,
}: Object) => (
  <React.Fragment>
    {(!controls || controls.onAdd) && (
      <Button color="primary" variant="contained" label="add" onClick={field.onAdd}>
        {t('general:actions.add')}
      </Button>
    )}
    {(!controls || controls.onDel) && (
      <a color="secondary" onClick={field.onDel} className={styles['form-control-text']}>
        {t('general:actions.remove')}
      </a>
    )}
  </React.Fragment>
);

export default translate()(observer(AddOrRemoveButtonControl));
